import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container mx-auto py-6 px-4 sm:px-0 relative" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-5 gap-3 sm:min-h-256" }
const _hoisted_3 = {
  key: 0,
  class: "col-span-4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")
  const _component_ExpenseModal = _resolveComponent("ExpenseModal")
  const _component_ExpenseSlideover = _resolveComponent("ExpenseSlideover")
  const _component_BudgetEditSummary = _resolveComponent("BudgetEditSummary")
  const _component_Alert = _resolveComponent("Alert")
  const _component_Select = _resolveComponent("Select")
  const _component_SideBar = _resolveComponent("SideBar")
  const _component_BudgetEditTable = _resolveComponent("BudgetEditTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationModal, {
      title: "Remove Expense",
      text: "Are you sure you want to remove this expense?",
      show: _ctx.showConfirmModal,
      "onUpdate:show": _cache[1] || (_cache[1] = $event => (_ctx.showConfirmModal = $event)),
      onConfirm: _cache[2] || (_cache[2] = $event => (_ctx.confirmRemoveExpense()))
    }, null, 8, ["show"]),
    _createVNode(_component_ExpenseModal, {
      class: "hidden lg:block",
      data: _ctx.expenseData,
      "edit-mode": true,
      show: _ctx.showModal,
      "onUpdate:show": _cache[3] || (_cache[3] = $event => (_ctx.showModal = $event)),
      type: _ctx.selectedCategory,
      "hide-sidebar": !!Object.keys(_ctx.expenseData).length,
      "onUpdate-budget": _cache[4] || (_cache[4] = $event => (_ctx.updateLocalBudget($event)))
    }, null, 8, ["data", "show", "type", "hide-sidebar"]),
    _createVNode(_component_ExpenseSlideover, {
      class: "block lg:hidden",
      show: _ctx.showModal,
      "onUpdate:show": _cache[5] || (_cache[5] = $event => (_ctx.showModal = $event)),
      data: _ctx.expenseData,
      type: _ctx.selectedCategory,
      "hide-sidebar": !!Object.keys(_ctx.expenseData).length,
      "onUpdate-budget": _cache[6] || (_cache[6] = $event => (_ctx.updateLocalBudget($event)))
    }, null, 8, ["show", "data", "type", "hide-sidebar"]),
    (_ctx.budget && _ctx.budget.expenses)
      ? _createVNode(_component_BudgetEditSummary, {
          key: 0,
          date: _ctx.budget.budget_cycle,
          "disable-save": _ctx.disableSave,
          expenses: _ctx.budget.expenses,
          "onAdd-expense": _cache[7] || (_cache[7] = $event => (_ctx.showModal = true)),
          "onSave-budget": _cache[8] || (_cache[8] = $event => (_ctx.saveBudget()))
        }, null, 8, ["date", "disable-save", "expenses"])
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      (!_ctx.alert.hide)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["absolute w-full top-0 left-0 transform transition duration-200 ease-in-out", {
				'-translate-y-12 opacity-100': _ctx.alert.show,
				'-translate-y-24 opacity-0': !_ctx.alert.show,
			}]
          }, [
            _createVNode(_component_Alert, {
              type: _ctx.alert.type,
              message: _ctx.alert.message
            }, null, 8, ["type", "message"])
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_component_Select, {
        class: "block md:hidden",
        items: _ctx.categories,
        "item-value": "slug",
        "item-label": "name",
        value: _ctx.selectedCategory,
        "onUpdate:value": _cache[9] || (_cache[9] = $event => (_ctx.selectedCategory = $event))
      }, null, 8, ["items", "value"]),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_SideBar, {
          notifications: _ctx.notifications,
          title: "Categories",
          items: _ctx.categories,
          "item-value": "slug",
          "item-label": "name",
          "selected-item": _ctx.selectedCategory,
          "onUpdate:selected-item": _cache[10] || (_cache[10] = $event => (_ctx.selectedCategory = $event))
        }, null, 8, ["notifications", "items", "selected-item"]),
        (!_ctx.loading)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_BudgetEditTable, {
                category: _ctx.selectedCategory,
                data: _ctx.budget.expenses,
                "onShow-expense-modal": _cache[11] || (_cache[11] = $event => (_ctx.showExpenseModal($event))),
                "onShow-remove-expense-modal": _cache[12] || (_cache[12] = $event => (
						_ctx.setDeleteAndShowConfirmation($event)
					))
              }, null, 8, ["category", "data"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}